import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import Button from '../../shared/components/Button/Button';
import LayoutAppHeader from '../../shared/components/Layout/components/container/LayoutAppHeader';
import Spinner from '../../shared/components/Spinner/Spinner';
import NotFoundImage from '../../shared/images/NotFoundImage.jpg';

const PageContainer = styled('div')`
  background-color: white;
  min-height: 100vh;
`;

const PageWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 64px;
  height: calc(100vh - 64px);
`;

const PageHeader = styled('h1')`
  font-family: 'Nunito Sans';
`;

const PageSubtext = styled('p')`
  margin-top: 20px;
  max-width: 480px;
  text-align: center;
  line-height: 1.6;
`;

const BackButton = styled('div')`
  margin-top: 25px;
`;

const ContentWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Image = styled('img')`
  height: 400px;
  margin-left: 20px;
  margin-bottom: 30px;
`;

const BuildUnavailableRoute = () => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const isUserLoaded = Object.keys(currentUser).length > 0;

  return (
    <PageContainer>
      <LayoutAppHeader />
      <PageWrapper>
        {isUserLoaded ? (
          <ContentWrapper>
            <Image src={NotFoundImage} />
            <PageHeader>Build is Temporarily Unavailable</PageHeader>
            <PageSubtext>
              We&apos;re sorry for the inconvenience — the new Build feature is temporarily
              down for maintenance. Your programs and data are safe. In the meantime,
              you can continue using the Calendar from the navigation above. We&apos;ll
              have Build back up as soon as possible.
            </PageSubtext>
            <BackButton>
              <Button
                onClick={() => {
                  window.location.href = '/';
                }}
                cta='Go to Home'
              />
            </BackButton>
          </ContentWrapper>
        ) : (
          <Spinner />
        )}
      </PageWrapper>
    </PageContainer>
  );
};

export default BuildUnavailableRoute;
